// Import main SCSS
import './scss/main.scss';

// Import all block styles
import './js/entry-styles.js';

// Import all block scripts
import './js/entry-scripts.js';
import './js/lazy-blocks.js';

// Import main JavaScript
import './js/main.js';
import './js/header.js';
import './js/announcement-banner.js';
import './js/lightbox.js';

// Import vendor libraries
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Export Swiper for global use
window.Swiper = Swiper;
window.SwiperModules = { Navigation, Pagination, Autoplay };
